"use client";

import React from "react";
import { FileAudio2 } from "lucide-react";

type AudioPlayerProps = {
  audioUrl: string;
  fileName: string;
};

export const AudioPlayer: React.FC<AudioPlayerProps> = ({ audioUrl, fileName }) => {
  if (!audioUrl) return null;
  
  return (
    <div className="fade-in slide-up p-5" style={{
      backdropFilter: 'blur(7px)',
      WebkitBackdropFilter: 'blur(7px)',
      borderRadius: 'var(--card-radius)',
      border: 'var(--glass-border)',
      boxShadow: 'var(--glass-shadow)'
    }}>
      <div className="flex items-center mb-3">
        <FileAudio2 className="h-5 w-5 text-primary mr-2" />
        <p className="text-sm font-medium text-foreground">アップロードした音声ファイル</p>
      </div>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-2 truncate">{fileName}</p>
      <audio controls src={audioUrl} className="w-full mt-2 rounded-md focus:outline-none focus:ring-1 focus:ring-primary">
        お使いのブラウザはオーディオタグをサポートしていません
      </audio>
    </div>
  );
}; 